import { createFileRoute, redirect } from "@tanstack/react-router";

// Dirección antigua: siempre se muestra la actual /recursos/subvenciones.
export const Route = createFileRoute("/panel/subvenciones")({
  beforeLoad: () => {
    throw redirect({ to: "/recursos/subvenciones", statusCode: 301 });
  },
});
